import React from 'react';
import { NotFoundSvg } from './illustrations/not-found-svg';

interface NotFoundErrorProps {
  message?: string;
}

export const NotFoundError: React.FC<NotFoundErrorProps> = ({ message }) => {
  return (
    <div className="text-center space-y-6 animate-in fade-in zoom-in-95 duration-500">
      {/* Dynamic SVG Illustration */}
      <div className="flex justify-center my-2">
        <NotFoundSvg />
      </div>

      {/* Heading & Subtitle */}
      <div className="space-y-3 max-w-lg mx-auto">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 dark:text-white tracking-tight">
          Page Not Found...
        </h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm sm:text-base leading-relaxed">
          {message || "The page you are looking for does not exist or an unexpected error occurred."}
        </p>
      </div>
    </div>
  );
};

export default NotFoundError;
